import { StarIcon, } from "@heroicons/react/24/outline";

export const StarRating = (props) => {
  // input
  const { rating = 0} = props;

  return (
    <span className="w-[100px] inline-flex flex-row justify-evenly items-center rounded-md bg-white px-2 py-1 text-xs font-medium shadow-sm text-gray-600 ring-1 ring-inset ring-gray-500/10">
      <StarIcon className="h-[15px] w-[15px]" color="orange"/>
      <p>{rating.toFixed(1)} Overall</p>
    </span>
  )
}